import { render } from "./CreateNews.vue?vue&type=template&id=25de05ce&scoped=true"
import script from "./CreateNews.vue?vue&type=script&lang=js"
export * from "./CreateNews.vue?vue&type=script&lang=js"

import "./CreateNews.vue?vue&type=style&index=0&id=25de05ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25de05ce"]])

export default __exports__